import { render } from "./FiltersComponent.vue?vue&type=template&id=f07f2248"
import script from "./FiltersComponent.vue?vue&type=script&lang=js"
export * from "./FiltersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__